export enum Storage {
  LANG = 'lang',
  TOKEN = 'token',
  PROFILE_ID = 'profileId'
}
